import * as Sentry from "@sentry/browser";
import { FC, useEffect } from "react";
import { useSelector } from "react-redux";

import { initGoogleFont } from "helpers/app";
import { runAppSagas } from "store/app-sagas";
import { selectIsAppLoaded } from "store/features/app/selectors";
import { wsManager } from "store/features/websocket/sagas";

import { CONNECTING, OPEN } from "../services/websocket/interfaces";

import AppLoader from "./AppLoader";
import AppRouter from "./AppRouter";

export const App: FC = () => {
  const loaded = useSelector(selectIsAppLoaded);

  useEffect(() => {
    runAppSagas();

    const handleWSConnection = (): void => {
      const { visibilityState } = document;
      if (
        visibilityState === "visible" &&
        wsManager.getReadyState() !== OPEN &&
        wsManager.getReadyState() !== CONNECTING
      ) {
        Sentry.withScope(scope => {
          scope.setExtra("readyState", JSON.stringify({ wsState: wsManager.getReadyState(), visibilityState }));
        });
        wsManager.reconnect();
      }
    };

    window.addEventListener("visibilitychange", handleWSConnection);
    initGoogleFont();

    return (): void => {
      window.removeEventListener("visibilitychange", handleWSConnection);
    };
  }, []);

  return loaded ? <AppRouter /> : <AppLoader />;
};
